import { Snackbar } from "@material-ui/core";

import {
  getAllFamilies,
  getAllSubFamiliesByFamilyId,
} from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import AddFamily from "../../ui/AddFamily";
import ConfirmAddCategory from "../../ui/ConfirmAddCategory";
import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../utils/UtilsFormule";
import ProductService from "../../services/ProductService";
import AddSubFamily from "../../ui/AddSubFamily";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const AddCategories = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const availableFamilies = useSelector(
    (state) => state.staff.availableFamilies
  );

  const availableSubFamilies = useSelector(
    (state) => state.staff.availableSubFamilies
  );
  const animatedComponents = makeAnimated();
  const [familySelectPlaceHolder, setFamilySelectPlaceHolder] = useState(
    "Choisir une famille de produits"
  );
  const [selectedOptionFamily, setSelectedOptionFamily] = useState(null);

  const [familyId, setFamilyId] = useState(0);
  const [sku, setSku] = useState("");
  const [typeFamily, setTypeFamily] = useState("");

  const [subFamilyId, setSubFamilyId] = useState(0);

  const [categoryName, setCategoryName] = useState("");
  const [subFamilyName, setSubFamilyName] = useState(null);
  const [categoryDesc, setCategoryDesc] = useState("");
  const [confirmSubFamilyModel, setConfirmSubFamilyModel] = useState();
  const [onAddFamily, setOnAddFamily] = useState(false);
  const [onConfirmAddSubFamily, setOnConfirmAddSubFamily] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [isCancel, setIsCancel] = useState(false);
  const [listSkus, setListSkus] = useState([]);
  const [onAddSubFamily, setOnAddSubFamily] = useState(false);
  const [allFamilly, setAllFamilly] = useState([]);
  const [subFamilySelectPlaceHolder, setSubFamilySelectPlaceHolder] = useState(
    "Choisir une sous famille de produits"
  );
  const [allSubFamilies, setAllSubFamilies] = useState([]);

  const [selectedOptionSubFamily, setSelectedOptionSubFamily] = useState(null);

  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  useEffect(() => {
    ProductService.getAllSkuCategory(getCurrentUserId(), 0).then((result) => {
      setListSkus(result.data["productCategory"]);
    });
    dispatch(getAllFamilies(0));
  }, []);

  useEffect(() => {
    if (
      onConfirmAddSubFamily === false &&
      confirmSubFamilyModel != null &&
      isCancel === false
    ) {
      setOpenSuccessAlert(true);
      setSuccessAlertText("Ajouté avec succès");
    }
  }, [onConfirmAddSubFamily]);

  useEffect(() => {
    setAllFamilly([]);

    availableFamilies &&
      availableFamilies.map((element, i) => {
        if (i === 0) {
          setFamilyId(element.id);
          setTypeFamily(element.type);
        }
        setAllFamilly((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: element.type,
          },
        ]);
      });
  }, [availableFamilies]);

  useEffect(() => {
    familyId && dispatch(getAllSubFamiliesByFamilyId(familyId));
  }, [familyId]);

  useEffect(() => {
    if (availableSubFamilies.length === 0) {
      setSubFamilyId(0);
    }
    setAllSubFamilies([]);

    availableSubFamilies &&
      availableSubFamilies.map((element, i) => {
        if (i === 0) {
          setSubFamilyId(element.id);
        }
        setAllSubFamilies((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            // customElements: element.type,
          },
        ]);
      });
  }, [availableSubFamilies]);

  const onChangeNameHandler = (event) => {
    setCategoryName(event.target.value);
  };

  const onChangeSubFamilyNameHandler = (event) => {
    setSubFamilyName(event.target.value);
  };

  const onChangeDescriptionHandler = (event) => {
    setCategoryDesc(event.target.value);
  };
  const onChangeSelectedFamily = (selectedOption) => {
    setSelectedOptionFamily();
    setFamilyId(selectedOption.value);
    setFamilySelectPlaceHolder(selectedOption.label);
    setTypeFamily(selectedOption.customElements);
  };
  const onChangeSelectedSubFamily = (selectedOption) => {
    setSelectedOptionSubFamily();
    setSubFamilyId(selectedOption.value);
    setSubFamilySelectPlaceHolder(selectedOption.label);
    // setTypeFamily(selectedOption.customElements);
  };
  const addButtonSubFamily = () => {
    // if (typeFamily !== "2") {
    //   return (
    //     <button class="btn btn-dark" onClick={onAddSubFamilyHandler}>
    //       <i class="fas fa-plus"></i>
    //     </button>
    //   );
    // } else {
    return (
      <button
        class="btn btn-dark"
        onClick={(e) => {
          navigate("/addSubFamily");
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
    // }
  };
  const onValidCategoryHandler = () => {
    if (categoryName === "") {
      setErrorAlertText("Erreur :le nom est vide ! ");
      setOpenErrorAlert(true);
    }else if (sku === ""||sku === null||sku === undefined) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :la référence est vide ! ");
    } else if (familyId === 0) {
      setErrorAlertText("Erreur :la famille est vide ! ");
      setOpenErrorAlert(true);
    } else if (subFamilyId !== 0) {
      let confirmSubFamilyModel = {
        categoryName: categoryName,
        description: categoryDesc,
        idProductFamily: familyId,
        idUserCreation: getCurrentUserId(),
        idProductSubFamily: subFamilyId,
        sku: sku,
      };

      ProductService.addProductCategory(confirmSubFamilyModel).then(
        (result) => {
          if (result.data["success"]) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/categories`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        }
      );
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const addButtonFamily = () => {
    return (
      <button
        class="btn btn-dark"
        onClick={(e) => {
          navigate("/addFamily");
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
    // if (typeFamily !== "2") {
    //   return (
    //     <button class="btn btn-dark" onClick={onAddFamilyHandler}>
    //       <i class="fas fa-plus"></i>
    //     </button>
    //   );
    // } else {
    //   return (
    //     <button
    //       class="btn btn-dark"
    //       onClick={(e) => {
    //         navigate("/addSubFamily");
    //       }}
    //     >
    //       <i class="fas fa-plus"></i>
    //     </button>
    //   );
    // }
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const blocSKU = () => {
    let skuPossible = UtilsFormule.generateSKUCategory(categoryName, listSkus);

    return (
      <div className="col-sm-6">
        <div className="form-group">
          <label htmlFor="inputName">Référence {skuPossible}</label>
          <input
            placeholder="Ajouter référence "
            onChange={onChangeReferenceHandler}
            type="text"
            id="inputName"
            className="form-control"
          />
        </div>
      </div>
    );
    // } else if (typeFamily === "1") {
    //   return <div class="row"></div>;
    // }
  };
  const onChangeReferenceHandler = (event) => {
    setSku(event.target.value);
  };
  const handleOnChangeFamily = (event) => {
    const selectedIndex = event.target.options.selectedIndex;
    let index =
      event.target.options[selectedIndex].getAttribute("indexOfElement");

    let family = availableFamilies[index];

    setFamilyId(family.id);
    setTypeFamily(family.type);
    setSubFamilyName(null);
  };
  // const onAddFamilyHandler = () => {
  //   setOnAddFamily(true);
  // };
  // const onAddSubFamilyHandler = () => {
  //   setOnAddSubFamily(true);
  // };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Catégorie</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title">
                    Ajouter une catégorie de produit
                  </h5>
                </div>
                <div className="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <div>
                          <label>Choisir la famille</label>
                          <div className="input-group">
                            <div
                              className="input-group-prepend"
                              style={{ width: "90%" }}
                            >
                              <Select
                                styles={styles}
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                defaultValue={selectedOptionFamily}
                                onChange={onChangeSelectedFamily}
                                options={allFamilly}
                                placeholder={familySelectPlaceHolder}
                              />
                            </div>
                            <div className=" input-group-append">
                              {addButtonFamily()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <div>
                          <label>Choisir la sous famille</label>
                          <div className="input-group">
                            <div
                              className="input-group-prepend"
                              style={{ width: "90%" }}
                            >
                              <Select
                                styles={styles}
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                defaultValue={selectedOptionSubFamily}
                                onChange={onChangeSelectedSubFamily}
                                autosize={false}
                                options={allSubFamilies}
                                placeholder={subFamilySelectPlaceHolder}
                              />
                            </div>
                            <div className=" input-group-append">
                              {addButtonSubFamily()}
                            </div>
                          </div>
                          {/* <select
                            value={subFamilyId || null}
                            onChange={(e) => setSubFamilyId(e.target.value)}
                            className="form-control select2"
                            style={{ width: "100%" }}
                          >
                            {availableSubFamilies &&
                              availableSubFamilies.map((element, index) =>
                                index === 0 ? (
                                  <option
                                    key={element.id}
                                    value={element.id}
                                    selected="selected"
                                  >
                                    {element.name}
                                  </option>
                                ) : (
                                  <option key={element.id} value={element.id}>
                                    {element.name}
                                  </option>
                                )
                              )}
                          </select> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-6">
                      <label htmlFor="inputName">Libellé</label>
                      <input
                        placeholder="Ajouter libellé "
                        onChange={onChangeNameHandler}
                        type="text"
                        id="inputName"
                        className="form-control"
                      />
                    </div>
                    {blocSKU()}
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputDescription">Description</label>
                        <textarea
                          placeholder="Saisir..."
                          onChange={onChangeDescriptionHandler}
                          id="inputDescription"
                          className="form-control"
                          rows={4}
                          defaultValue={""}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div class="col-sm-5"> </div> */}
                </div>
                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidCategoryHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      {onAddSubFamily && (
        <AddSubFamily
          familyId={familyId}
          setOnAddSubFamily={setOnAddSubFamily}
        />
      )}
      {onAddFamily && <AddFamily setOnAddFamily={setOnAddFamily} />}
      {/* {onConfirmAddSubFamily && (
        <ConfirmAddCategory
          setOnConfirmAddSubFamily={setOnConfirmAddSubFamily}
          confirmSubFamilyModel={confirmSubFamilyModel}
          setIsCancel={setIsCancel}
        />
      )} */}
    </div>
  );
};
export default AddCategories;
